export const OLD_FORMAT_REGEX = /^[A-Z]{3}[0-9]{4}$/;
export const MERCOSUL_REGEX = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/;
